import { useNavigate } from "react-router-dom";
import { ClipboardList, FileText, Gamepad2 } from "lucide-react";
import { Typography } from "../atoms/Typography";
import type { LibraryTile } from "../../data/library";

const tileIcon = (id: string) => {
  switch (id) {
    case "contracts":
      return FileText;
    case "rfps":
      return ClipboardList;
    case "rules":
      return Gamepad2;
    default:
      return FileText;
  }
};

type LibraryGridProps = {
  readonly tiles: readonly LibraryTile[];
};

export const LibraryGrid = ({ tiles }: LibraryGridProps) => {
  const navigate = useNavigate();

  return (
    <div className="grid gap-6 md:grid-cols-3 md:gap-8">
      {tiles.map((tile) => {
        const Icon = tileIcon(tile.id);
        return (
          <button
            key={tile.id}
            type="button"
            onClick={() => navigate(tile.href)}
            className="flex flex-col items-start gap-4 rounded-2xl border border-gray-200 bg-white p-6 text-left shadow-sm transition-shadow hover:shadow-md"
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-50 text-primary-600">
              <Icon className="h-6 w-6" />
            </div>
            <div>
              <Typography as="h2" variant="h3" className="mb-2">
                {tile.title}
              </Typography>
              <p className="text-sm text-gray-600">{tile.description}</p>
            </div>
          </button>
        );
      })}
    </div>
  );
};
